export default __webpack_public_path__ + "static/media/1121.32f8d296.png";